import MnVideo from "./mn-video";
import MnAudio from "./mn-audio";
import Common from "./mn-common";
import ball from "/public/svg/ball-triangle.svg";
import MnWorker from "./mn-worker.js?worker";
import TimerCtrl from "./timerCtrl";
// console.log("MnWorker", MnWorker);
// const modules = import.meta.glob("./mn-worker.js", {
//   eager: true,
//   query: "?url&no-inline",
//   import: "default",
// });

// console.log(modules);
/**
 * @description: 播放控制类
 * @author: lantf
 * @date: 2020/10/18 15:30
 */

const decoderStateIdle = 0;
const decoderStateInit = 1;
const decoderStateReady = 2;

const playerStateIdle = 0;
const playerStatePlaying = 1;
const playerStatePausing = 2;

class MnPlayer {
  host = "";
  port = 0;
  deviceType = "1";
  userId = "";
  tenantId = "";
  token = "";
  ws = "";
  renderMode = 0; // 0 - wasm , 1 - videoDecoder
  frameCache = [];
  renderType = true;
  timeCallback = null;
  lastDrawTime = 0;
  timerCtrl = null;
  onPaused = () => {};
  onPlaying = () => {};

  constructor(phone, channel, div, canvas, lang, renderType = "wasm") {
    this.phone = phone;
    this.outerWorker = null;
    this.channel = channel;
    this.div = div;
    this.chlId = "chlId";
    this.spedId = "spedId";
    this.loadId = null;
    this.hintId = null;
    this.loading = true;
    this.canvas = canvas;
    this.lang = lang;
    this.streamTime = null;
    this.replayTimer = null;
    this.isFirstLoad = false;
    this.frameCache = [];
    this.renderType = renderType;

    this.messageId = 0;
    this.mediaType = -1;
    this.streamType = -1;
    this.beginTime = "";
    this.isPlayback = false;
    this.timeout = 30000;
    this.playbackMode = null;
    this.width = 0;
    this.height = 0;
    this.yLength = 0;
    this.uvLength = 0;

    this.mnVideo = null;
    this.mnAudio = null;
    this.mnWorker = null;
    this.playAudio = false;
    this.playerState = playerStateIdle;
    this.decoderState = decoderStateIdle;

    this.audioEncoding = "16bitInt";
    this.audioChannels = 1;
    this.audioSampleRate = 8000;
    this.supportH264 = false;
    this.supportH265 = false;
    this.videoTimeStamp = 0;
    this.audioTimeStamp = 0;
    this.lastAudioTimeStamp = 0;
    this.isAbnormal = false;
    this.isNormalTime = 0;
    this.speed = 1;
    this.decodeSlow = false;
    this.isDetectAbnormal = false;

    this.logger = new Common.Logger("MnPlayer");

    this.mnAudio = new MnAudio({
      encoding: this.audioEncoding,
      channels: this.audioChannels,
      sampleRate: this.audioSampleRate,
      flushingTime: 1000,
    });
    this.enableAudio(this.playAudio);

    let self = this;
    window.addEventListener("online", function () {
      self.online();
    });
    window.addEventListener("offline", function () {
      self.offline();
    });
    this.isSupportH264().then((res) => {
      this.supportH264 = res;
    });
    this.isSupportH265().then((res) => {
      this.supportH265 = res;
    });
    this.timerCtrl = new TimerCtrl((data) => {
      if (data.time) {
        if (this.timeCallback && typeof this.timeCallback == "function") {
          this.timeCallback(new Date(data.time - 1000 * 60 * 60 * 8).getTime());
        }
        this.handleAudioVideoTimeCheck(+data.time);
      }
      let videoTime = new CustomEvent("videoTime", {
        detail: {
          data: data.time,
        },
      });
      if (window.dispatchEvent) {
        window.dispatchEvent(videoTime);
      } else {
        window.fireEvent(videoTime);
      }
      if (this.renderMode == 0) {
        data = data.data;
        if (this.mnVideo != null) {
          this.mnVideo.renderFrame(
            data,
            this.width,
            this.height,
            this.yLength,
            this.uvLength,
          );
        } else {
          console.log("mnVideo is null.");
        }
      } else {
        this.drawOne(data.data);
      }
    });
    this.timerCtrl.onSpeedChange = (num) => {
      console.log("太慢了变速", num);
      this.changeSpeed(num, false);
    };
  }

  /**
   * 网络恢复
   **/
  online() {
    this.openStream();
  }

  /**
   * 网络中断
   **/
  offline() {
    this.stopReplayTimer();
    this.stopWorker(true);
    this.hidePrompt();

    let message = "1连接异常，请检查网络";
    switch (this.lang) {
      case "zh-CN,zh;":
        message = "1连接异常，请检查网络";
        break;
      case "zh-TW,zh;":
        message = "1連接異常，請檢查網絡";
        break;
      case "en-US,en;":
        message = "1The connection is abnormal. Please check network";
        break;
      case "ru-RU,ru;":
        message = "1Ошибка подключения к видео серверу";
        break;
      case "kk-KZ,kk;":
        message = "1Видео серверіне қосылу жаңылысы";
        break;
    }
    let objData = {
      t: Common.kSocketErrorRsp,
      d: message,
    };
    this.onStringFrame(objData);
  }

  /**
   * 初始化工作者线程（码流接收、解码）
   **/

  initMnWorker() {
    // console.log('initMnWorker');
    let self = this;
    try {
      // console.log('outerWorker',this.outerWorker)
      if (this.outerWorker) {
        this.mnWorker = this.outerWorker;
      } else {
        this.mnWorker = new MnWorker({
          type: "module",
        });
      }
    } catch (e) {
      console.log("初始化工作者线程失败", e);
    }
    this.renderMode = 0;
    // console.log("this.renderType", this.renderType);
    if (this.renderType == "decode" && this.initVideoDecoder()) {
      this.renderMode = 1;
    } else {
      this.renderMode = 0;
      if (this.canvas != null) {
        console.log("加载MnVideo");
        this.mnVideo = new MnVideo(this.canvas, {
          preserveDrawingBuffer: false,
        });
      }
    }
    if (this.mnAudio === null) {
      this.mnAudio = this.mnAudio = new MnAudio({
        encoding: this.audioEncoding,
        channels: this.audioChannels,
        sampleRate: this.audioSampleRate,
        flushingTime: 1000,
      });
      this.enableAudio(this.playAudio);
    }

    this.mnWorker.onmessage = function (evt) {
      let objData = evt.data;
      switch (objData.t) {
        case Common.kVideoFrameOriginRsp:
          self.decodeVideoFrame(objData.d, objData.ti, objData.isKey);
          break;
        case Common.kOpenDecoderRsp:
          self.onOpenDecoder(objData);
          break;
        case Common.kVideoReady:
          self.onVideoReady(objData);
          break;
        case Common.kVideoFrame:
          self.onVideoFrame(objData);
          self.mnAudio.videoReady();
          break;
        case Common.kAudioFrame:
          self.onAudioFrame(objData);
          break;
        case Common.kFlushAudio:
          // console.log("主动flush音频", objData);
          self.mnAudio?.flush();
          break;
        case Common.kNetSpeedFrame:
          self.onNetSpeedFrame(objData);
          break;
        case Common.kStringFrame:
          self.onStringFrame(objData);
          break;
        case Common.kNoCache:
          self.onNoCache(objData);
          break;
        case Common.kCacheAvailable:
          self.onCacheAvailable(objData);
          break;
        case Common.kSocketErrorRsp:
        case Common.kSocketCloseRsp:
          self.stopWorker(false);
          self.onStringFrame(objData);
          break;
      }
    };
    this.mnWorker.postMessage({
      t: Common.kOpenDecoderReq,
      renderMode: this.renderMode,
      host: this.host,
      port: this.port,
      userId: this.userId,
      tenantId: this.tenantId,
      token: this.token,
      deviceType: this.deviceType,
      ws: this.ws,
      phone: this.phone,
      channel: this.channel,
      lang: this.lang,
    });
  }
  changeRenderType(type) {
    this.renderMode = type;
    console.log(
      "改变renderMode",
      type,
      this.mnWorker.postMessage,
      Common.kChangeRenderTypeReq,
    );
    this.mnWorker.postMessage({
      t: Common.kChangeRenderTypeReq,
      renderMode: this.renderMode,
    });
  }
  /**
   * 停止重连定时器
   **/
  stopReplayTimer() {
    if (this.replayTimer) {
      clearInterval(this.replayTimer);
      this.replayTimer = null;
    }
  }

  /**
   * 停止工作者线程
   **/
  stopWorker(pasv) {
    if (this.mnWorker) {
      if (pasv) {
        this.mnWorker.postMessage({
          t: Common.kCloseStreamReq,
        });
      }
      this.mnWorker.terminate();
      this.mnWorker = null;
    }
  }
  resetAudioOffset(time = 0) {
    this.mnAudio?.resetAudioByTimeStamp(time);
  }
  onNoCache(objData) {
    // console.log("缓存不足提示", objData.len);
    this.pause();
  }
  onCacheAvailable(objData) {
    // console.log("缓存恢复提示", objData.len);
    this.resume();
  }
  /**
   * 开始播放
   **/
  play(mediaType, streamType, beginTime) {
    do {
      if (this.playerState == playerStatePausing) {
        this.resume();
        break;
      }
      this.onPlaying();
      if (this.playerState == playerStatePlaying) {
        break;
      }
      // if (mediaType == this.mediaType && streamType == this.streamType) {
      //   break;
      // }
      console.log("开始播放");

      this.mediaType = mediaType;
      this.streamType = streamType;
      this.beginTime = beginTime;
      this.isPlayback = false;
      if (beginTime == null || beginTime.length == 0) {
        this.messageId = 0x9101;
      } else {
        /* 回放 */
        // this.renderMode = 1;
        this.isPlayback = true;
        if (this.playbackMode == null) {
          this.playbackMode = 0;
          this.messageId = 0x9201;
        } else {
          this.playbackMode = 5;
          this.messageId = 0x9202;
        }
      }

      if (!this.canvas && this.mediaType != Common.kMediaSpeak) {
        this.logger.logError("[ER] playVideo error, canvas empty.");
        break;
      }

      if (this.mediaType != Common.kMediaSpeak) {
        this.showChannel();
      }
      this.openStream();
      this.playerState = playerStatePlaying;
      // console.log("playerState", this.playerState);
    } while (false);
  }

  /**
   * 请求码流
   **/
  openStream() {
    if (this.mnWorker == null) {
      this.initMnWorker();
    }
    this.mnWorker.postMessage({
      t: Common.kOpenStreamReq,
      messageId: this.messageId,
      mediaType: this.mediaType,
      streamType: this.streamType,
      beginTime: this.beginTime,
      playbackMode: this.playbackMode,
      lang: this.lang,
    });
    if (this.replayTimer == null && this.mediaType !== Common.kMediaSpeak) {
      this.replayTimer = setInterval(
        this.detectStream.bind(this),
        this.timeout,
      );
    }

    this.showLoading();
  }

  /**
   * 快进
   **/
  fastForward(ff) {
    if (this.mnWorker) {
      this.mnWorker.postMessage({
        t: Common.kFastForward,
        d: ff,
      });
    }
  }

  /**
   * 恢复播放
   **/
  resume() {
    this.onPlaying();
    if (this.playerState != playerStatePausing) {
      this.logger.logInfo("Not pausing.");
      return;
    }

    if (this.mnAudio != null) {
      this.mnAudio.resume();
    }
    let req = {
      t: Common.kResumeDecodingReq,
    };
    this.mnWorker.postMessage(req);

    this.playerState = playerStatePlaying;
    this.timerCtrl.resume();
  }

  /**
   * 暂停播放
   **/
  pause() {
    this.onPaused();
    if (this.playerState != playerStatePlaying) {
      this.logger.logInfo("Not playing.");
      return;
    }
    if (!this.isPlayback) {
      /* 清除音频数据 */
      console.log("清除音频数据");
      this.mnAudio?.clear();
    }

    this.playerState = playerStatePausing;

    if (this.mnAudio != null) {
      this.mnAudio.pause();
    }

    let req = {
      t: Common.kPauseDecodingReq,
    };
    this.mnWorker.postMessage(req);
    this.timerCtrl.pause();
  }
  offsetVideo(time) {
    this.timerCtrl.offset(time);
    let req = {
      t: Common.kVideoAudioOffset,
      data: time,
    };
    this.mnWorker.postMessage(req);
  }
  /**
   * 停止播放
   **/
  async stop() {
    if (this.playerState == playerStateIdle) {
      this.logger.logInfo("Not playing.");
      return;
    }
    this.timerCtrl?.stop();
    this.playbackMode = null;

    this.stopReplayTimer();

    this.playerState = playerStateIdle;
    this.decoderState = decoderStateIdle;
    this.stopWorker(true);
    if (this.mnVideo) {
      this.mnVideo.stop();
      this.canvas = null;
      this.mnVideo = null;
    }

    if (this.mnAudio) {
      this.enableAudio(false);
      this.mnAudio.destroy();
      this.mnAudio = null;
    }
    // 关闭VideoDecoder
    await this.closeVideoDecoder();
    this.streamType = -1;

    if (this.div != null) {
      this.hidePrompt();
      this.div.find("#" + this.chlId).remove();
      this.div.find("#" + this.spedId).remove();
    }
  }

  /**
   * 切换码流类型
   **/
  switchStream(streamType) {
    if (this.streamType == streamType) {
      return;
    }

    this.streamType = streamType;
    let req = {
      t: Common.kSwitchStreamReq,
      s: streamType,
    };

    this.mnWorker.postMessage(req);
  }

  /**
   * 音频开、关
   **/
  enableAudio(enable) {
    // console.log("改变音频状态1", enable);

    // if (this.mediaType == Common.kMediaSpeak) {
    //   return;
    // }

    // if (this.playAudio === enable) {
    //   return;
    // }
    // console.log("改变音频状态", enable);
    this.playAudio = enable;
    if (this.playAudio) {
      this.mnAudio.volume(1);
    } else {
      this.mnAudio.volume(0);
    }
    let req = {
      t: Common.kEnableAudioReq,
      d: enable,
    };

    this.mnWorker?.postMessage(req);
  }

  /**
   * 发送录音数据（语音调度，一对多，单向）
   **/
  speak(data) {
    if (this.decoderState !== decoderStateReady) {
      return;
    }
    let objData = {
      t: Common.kRecorderSpeakReq,
      d: data,
    };
    this.mnWorker.postMessage(objData, objData.d.buffer);
  }

  /**
   * 发送录音数据（对讲，一对一，双向）
   **/
  talk(data) {
    if (this.decoderState !== decoderStateReady) {
      return;
    }

    let objData = {
      t: Common.kRecorderTalkReq,
      d: data,
    };
    this.mnWorker?.postMessage(objData, [objData.d.buffer]);
  }

  /**
   * 全屏播放
   **/
  fullscreen() {
    if (this.mnVideo) {
      this.mnVideo.fullscreen();
    }
  }

  /**
   * 响应解码器打开
   **/
  onOpenDecoder(objData) {
    if (objData.e == 0) {
      this.decoderState = decoderStateReady;
      if (this.mediaType == Common.kMediaSpeak) {
        this.playAudio = true;
      }
    } else {
      this.logger.logError("Open decoder response " + objData.e + ".");
    }
  }

  /**
   * 超过timeout秒没有收到码流，则重新请求
   **/
  detectStream() {
    if (this.playerState == playerStatePausing) {
      return;
    }

    if (Date.now() - this.streamTime >= this.timeout) {
      this.isDetectAbnormal = true;
      if (!this.loading) {
        if (this.renderType == "decode") {
          this.restartCallback?.();
          return;
        }
        if (this.mnWorker == null) {
          this.openStream();
        } else {
          this.mnWorker.postMessage({
            t: Common.kReplayReq,
          });
        }
        this.showLoading();
      } else {
        let message = "码流响应超时";
        switch (this.lang) {
          case "zh-CN,zh;":
            message = "码流响应超时";
            break;
          case "zh-TW,zh;":
            message = "碼流響應超時";
            break;
          case "en-US,en;":
            message = "Stream response timeout";
            break;
          case "ru-RU,ru;":
            message = "Тайм-аут ответа на поток";
            break;
          case "kk-KZ,kk;":
            message = "Трансляцияға жауап берудің күту уақыты";
            break;
        }
        this.showHinting(message);
      }
      this.loading = !this.loading;
    } else {
      this.isDetectAbnormal = false;
    }
  }

  /**
   * 响应YUV视频帧宽、高
   **/
  onVideoReady(frame) {
    this.width = frame.w;
    this.height = frame.h;
    this.yLength = frame.w * frame.h;
    this.uvLength = (frame.w / 2) * (frame.h / 2);
  }

  /**
   * 响应YUV视频帧
   **/
  onVideoFrame(frame) {
    this.hidePrompt();
    this.hideChannel();
    this.streamTime = Date.now();
    let data = new Uint8Array(frame.d);
    if (!this.isPlayback) {
      this.timerCtrl.append(+frame.ti, data);
      this.timerCtrl.isRealTime = !this.isPlayback;
      if (this.timerCtrl.getCacheSize > 10) {
        this.timerCtrl.resume();
      }
    } else {
      if (this.mnVideo != null) {
        if(this.playerState == playerStatePausing) {
          return;
        }
        this.mnVideo.renderFrame(
          data,
          this.width,
          this.height,
          this.yLength,
          this.uvLength,
        );
      } else {
        console.log("mnVideo is null.");
      }
      if (this.timeCallback && typeof this.timeCallback == "function") {
        this.timeCallback(new Date(+frame.ti - 1000 * 60 * 60 * 8).getTime());
      }
      let videoTime = new CustomEvent("videoTime", {
        detail: {
          data: +frame.ti,
        },
      });
      if (window.dispatchEvent) {
        window.dispatchEvent(videoTime);
      } else {
        window.fireEvent(videoTime);
      }
    }
  }

  /**
   * 响应PCM音频帧
   **/
  onAudioFrame(frame) {
    // if (this.playerState != playerStatePlaying) {
    //   return;
    // }
    let data = new Uint8Array(frame.d);
    this.mnAudio.feed(data, frame.ti);
  }

  /**
   * 响应String帧
   **/
  onStringFrame(frame) {
    let text = frame.d;
    if (text == null) {
      return;
    }
    if (text.charAt(0) === "0") {
    } else if (text.charAt(0) === "1") {
      this.showHinting(text.substr(1));
      this.loading = false;
    } else if (text.charAt(0) === "2") {
      let gpsData = new CustomEvent("gpsData", {
        detail: {
          data: text.substr(1),
        },
      });
      if (window.dispatchEvent) {
        window.dispatchEvent(gpsData);
      } else {
        window.fireEvent(gpsData);
      }
    }
  }

  onNetSpeedFrame(frame) {
    let span;
    let speed = parseInt(frame.d / 1024, 10);
    if (this.videoDecoder) {
      if (this.isPlayback) {
        speed = `${speed}KB/S;${this.renderMode == 0 ? "Wasm" : "Decoder"};cache:${frame.len};que:${this.videoDecoder?.decodeQueueSize || 0};`;
      } else {
        speed = `${speed}KB/S;${this.renderMode == 0 ? "Wasm" : "Decoder"};cache:${this.timerCtrl.getCacheSize()};que:${this.videoDecoder?.decodeQueueSize || 0};`;
      }
    } else {
      if (this.isPlayback) {
        speed = `${speed}KB/S;${this.renderMode == 0 ? "Wasm" : "Decoder"};cache:${frame.len}`;
      } else {
        speed = `${speed}KB/S;${this.renderMode == 0 ? "Wasm" : "Decoder"};cache:${this.timerCtrl.getCacheSize()}`;
      }
    }

    if (this.div !== undefined && this.div !== null) {
      if (this.spedId != null) {
        this.div.find("#" + this.spedId).remove();
      }
      span =
        '<span id="' +
        this.spedId +
        '" style="position: absolute;bottom:0;right:0;transform:translate(-10px,-10px);font-size:1.0vh;color:white;width:auto">' +
        speed +
        "</span>";
      this.div.append(span);
    }
  }

  /**
   * 显示通道号
   **/
  showChannel() {
    let span;

    this.hideChannel();

    this.chlId = "chlId";

    if (this.streamType == 0) {
      span =
        '<span id="' +
        this.chlId +
        '" style="position: absolute;top:3%;right:2%;transform:translate(-50%,-50%);font-size:3.0vh;color:white;width:auto">' +
        this.channel +
        "</span>";
    } else {
      span =
        '<span id="' +
        this.chlId +
        '" style="position: absolute;top:5%;right:2%;transform:translate(-50%,-50%);font-size:1.0vh;color:white;width:auto">' +
        this.channel +
        "</span>";
    }
    if (this.div != null) {
      this.div.append(span);
    }
  }

  /**
   * 显示通道号
   **/
  hideChannel() {
    if (this.div != null && this.chlId != null) {
      this.div.find("#" + this.chlId).remove();
      this.chlId = null;
    }
  }

  /**
   * 隐藏加载指示
   **/
  showLoading() {
    if (this.mediaType == Common.kMediaSpeak) {
      return;
    }

    this.hidePrompt();

    this.loadId = "loadId";
    if (this.div != null) {
      this.div.append(
        '<img class="avue-home__loading" id="' +
          this.loadId +
          '" width="30" height="30" style="position: absolute;top: 50%;left: 50%;transform: translate(-50%,-50%);" src="' +
          ball +
          '" alt="loading">',
      );
    }
  }

  /**
   * 隐藏加载指示
   **/
  hideLoading() {
    if (this.div != null && this.loadId != null) {
      this.div.find("#" + this.loadId).remove();
      this.loadId = null;
    }
  }

  /**
   * 显示提示信息
   **/
  showHinting(text) {
    if (this.mediaType == Common.kMediaSpeak) {
      return;
    }

    this.hidePrompt();

    this.hintId = "hintId";
    this.div.append(
      '<span id="' +
        this.hintId +
        '" style="position: absolute;top: 50%;left: 50%;transform: translate(-50%,-50%);font-size: 1.5vh;color: red;width: auto">' +
        text +
        "</span>",
    );
  }

  /**
   * 隐藏文字提示
   **/
  hideHinting() {
    if (this.mediaType == Common.kMediaSpeak) {
      return;
    }

    if (this.div != null && this.hintId != null) {
      this.div.find("#" + this.hintId).remove();
      this.hintId = null;
    }
  }

  /**
   * 隐藏提示
   **/
  hidePrompt() {
    this.hideLoading();
    this.hideHinting();
  }

  async isSupportH265() {
    try {
      if (VideoDecoder) {
        const config = {
          codec: "hev1.1.6.L93.B0", // H265
          hardwareAcceleration: "prefer-hardware",
        };
        const support = await VideoDecoder.isConfigSupported(config);
        // console.log("是否支持H265:", support.supported);
        return true;
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  }
  async isSupportH264() {
    try {
      if (VideoDecoder) {
        const config = {
          codec: "avc1.42001E", // H264 基础配置
          hardwareAcceleration: "prefer-hardware",
        };
        const support = await VideoDecoder.isConfigSupported(config);
        // console.log("是否支持H264:", support.supported);
        return true;
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  }

  /* VideoDecoder 解码 */

  /**
   * 初始化 VideoDecoder
   * @param {Object} config - 解码器配置
   */
  initVideoDecoder(config = {}) {
    if (!("VideoDecoder" in window)) {
      console.warn("VideoDecoder is not supported in this browser");
      return false;
    }

    const defaultConfig = {
      codec: "avc1.42001E", // H264 基础配置
      // codec: "avc1.640028", // H265
      width: this.width || 640,
      height: this.height || 480,
      hardwareAcceleration: "prefer-hardware",
      description: this.avcC,
    };

    const finalConfig = { ...defaultConfig, ...config };

    // 检查配置是否支持
    VideoDecoder.isConfigSupported(finalConfig)
      .then((support) => {
        if (!support.supported) {
          console.warn("VideoDecoder config is not supported:", finalConfig);
          alert("不支持");
          return;
        }

        // 创建解码器
        // console.log("finalConfig", finalConfig);
        this.videoDecoder = new VideoDecoder({
          output: this.handleDecodedFrame.bind(this),
          error: this.handleDecoderError.bind(this),
        });

        this.videoDecoder._id = this.id;
        console.log("initVideoDecoder ID:", this.videoDecoder._id);

        // 配置解码器
        this.videoDecoder.configure(finalConfig);
        console.log("VideoDecoder initialized successfully");
      })
      .catch((error) => {
        console.error("Failed to initialize VideoDecoder:", error);
      });

    return true;
  }
  handleAudioVideoTimeCheck(videoTime) {
    let t = +this.mnAudio.getNowPlayStamp();
    if (t == -1) {
      return;
    }
    this.audioTimeStamp = t;
    // console.log("音频时间", new Date(this.audioTimeStamp).toUTCString());
    // console.log("视频时间", new Date(videoTime).toUTCString());
    let d = videoTime - this.audioTimeStamp;
    // console.log("视频时间差", d);
    /* --- 处理音视频追踪功能 --- */

    this.lastAudioTimeStamp = this.audioTimeStamp;
    this.videoTimeStamp = +videoTime;
    this.audioTimeStamp = +this.mnAudio.getNowPlayStamp();
    // console.log('视频，音频时间',new Date(this.videoTimeStamp).toUTCString(),new Date(this.audioTimeStamp).toUTCString(),this.videoTimeStamp - this.audioTimeStamp)
    const isNowAbnormal =
      this.audioTimeStamp == 0 ||
      this.audioTimeStamp == -1 ||
      isNaN(this.audioTimeStamp);

    if (this.isAbnormal) {
      /* 当存在连续正常恢复同步功能 */
      if (this.videoTimeStamp - this.lastAudioTimeStamp > 0 && !isNowAbnormal) {
        this.isNormalTime++;
      } else {
        this.isNormalTime = 0;
      }
      if (this.isNormalTime > 10) {
        this.isAbnormal = false;
      }
      return;
    }

    if (isNowAbnormal) {
      // console.log("异常音频忽略音视频同步");
      this.isAbnormal = true;
      this.offsetVideo(0);
      return;
    }
    if (this.lastAudioTimeStamp === 0) {
      return;
    }
    if (this.audioTimeStamp - this.lastAudioTimeStamp > 1000) {
      /* 时间跨度超过1s 认为是跨段 跨段时需要忽略音视频同步问题 */
      this.isAbnormal = true;
      return;
    }
    /* 倍速情况下忽略 */
    if (this.speed <= 2) {
      /* 当出现音频视频严重分离时直接强制同步 */
      if (this.videoTimeStamp - this.audioTimeStamp > 2000) {
        console.log("强制同步音视频");
        this.resetAudioOffset(this.videoTimeStamp);
      }
      // if (this.videoTimeStamp - this.audioTimeStamp < -6000) {
      //   console.log(
      //     "视频音频严重不同步 重载!",
      //     this.videoTimeStamp - this.audioTimeStamp,
      //   );
      //   MnPlayer.restartCallback?.();
      // }
      const offsetT = this.mnAudio.offsetAudio(this.videoTimeStamp);
      this.offsetVideo(offsetT);
    }
  }
  /**
   * 处理解码后的视频帧 解码断断续续的
   * @param {VideoFrame} frame - 解码后的视频帧
   */
  handleDecodedFrame(frame) {
    this.hidePrompt();
    // this.frameCache.push(frame);
    this.timerCtrl.append(frame.timestamp / 1000, frame);
    if (this.decodeSlow && this.videoDecoder.decodeQueueSize <= 20) {
      this.decodeSlow = false;
      this.mnWorker.postMessage({
        t: Common.kResumeDecodingReq,
      });
    }
  }
  /* 绘制一帧 */
  drawOne(frame) {
    if (!this.canvas) return;
    const ctx = this.canvas.getContext("2d");
    if (!ctx) return;
    // 绘制视频帧到画布
    // if (this.frameCache.length < 5) return;
    // const frame = this.frameCache.shift();
    this.mnAudio.videoReady();
    // console.log(
    //   "frame",
    //   frame.displayWidth,
    //   frame.displayHeight,
    //   frame.codedWidth,
    //   frame.codedHeight,
    //   frame.codedRect,
    // );
    if (!frame) return;

    // ctx.drawImage(frame, 0, 0, this.canvas.width, this.canvas.height);
    try {
      ctx.drawImage(frame, 0, 0, this.canvas.width, this.canvas.height);
      // if (this.timeCallback && typeof this.timeCallback == "function") {
      //   this.timeCallback(frame.timestamp / 1000 - 8 * 60 * 60 * 1000);
      //   this.handleAudioVideoTimeCheck(+frame.timestamp / 1000);
      // }
    } catch (e) {}
    // 释放帧资源
    frame.close();
  }

  /**
   * 处理解码器错误
   * @param {Error} error - 解码错误
   */
  handleDecoderError(error) {
    if (this.decodeSlow && this.videoDecoder.decodeQueueSize <= 20) {
      this.decodeSlow = false;
      this.mnWorker.postMessage({
        t: Common.kResumeDecodingReq,
      });
    }
    /* 重启 */
    if (this.playerState == playerStatePlaying) {
      // this.restartCallback?.();
      if (this.videoDecoder.state == "closed") {
        this.initVideoDecoder();
      }
      this.isFirstLoad = false;
    }
  }
  dropLast16Bytes(buffer) {
    if (buffer.byteLength <= 16) {
      return new ArrayBuffer(0);
    }
    return buffer.slice(0, buffer.byteLength - 16);
  }

  annexBToAvcc(nalus) {
    const total = nalus.reduce((s, n) => s + 4 + n.length, 0);
    const out = new Uint8Array(total);
    let offset = 0;

    for (const nalu of nalus) {
      out[offset++] = (nalu.length >>> 24) & 0xff;
      out[offset++] = (nalu.length >>> 16) & 0xff;
      out[offset++] = (nalu.length >>> 8) & 0xff;
      out[offset++] = nalu.length & 0xff;
      out.set(nalu, offset);
      offset += nalu.length;
    }

    return out;
  }
  splitAnnexBNalus(buffer) {
    const nalus = [];
    let i = 0;

    function isStartCode(pos) {
      return (
        buffer[pos] === 0x00 &&
        buffer[pos + 1] === 0x00 &&
        (buffer[pos + 2] === 0x01 ||
          (buffer[pos + 2] === 0x00 && buffer[pos + 3] === 0x01))
      );
    }

    while (i < buffer.length) {
      if (!isStartCode(i)) {
        i++;
        continue;
      }

      const start = buffer[i + (buffer[i + 2] === 0x01 ? 3 : 4)];
      const naluStart = i + (buffer[i + 2] === 0x01 ? 3 : 4);

      let j = naluStart;
      while (j < buffer.length && !isStartCode(j)) j++;

      nalus.push(buffer.subarray(naluStart, j));
      i = j;
    }

    return nalus;
  }
  extractSpsPps(data) {
    let sps = null;
    let pps = null;

    let i = 0;

    while (i + 4 < data.length) {
      // 查 start code
      if (
        data[i] === 0x00 &&
        data[i + 1] === 0x00 &&
        (data[i + 2] === 0x01 || (data[i + 2] === 0x00 && data[i + 3] === 0x01))
      ) {
        const startCodeLength = data[i + 2] === 0x01 ? 3 : 4;
        const nalStart = i + startCodeLength;
        const nalType = data[nalStart] & 0x1f;

        // 找下一个 start code
        let nalEnd = nalStart + 1;
        while (
          nalEnd + 3 < data.length &&
          !(
            data[nalEnd] === 0x00 &&
            data[nalEnd + 1] === 0x00 &&
            (data[nalEnd + 2] === 0x01 ||
              (data[nalEnd + 2] === 0x00 && data[nalEnd + 3] === 0x01))
          )
        ) {
          nalEnd++;
        }

        const nalUnit = data.slice(nalStart, nalEnd);
        if (nalType === 7 && !sps) sps = nalUnit;
        if (nalType === 8 && !pps) pps = nalUnit;
        /* 265 */
        if (nalType === 32 && !sps) sps = nalUnit;
        if (nalType === 33 && !pps) pps = nalUnit;

        if (sps && pps) break;

        i = nalEnd;
      } else {
        i++;
      }
    }

    return { sps, pps };
  }

  extractVpsSpsPps(buffer) {
    /* : { type: number, data: Uint8Array }[] */
    const naluList = [];
    let offset = 0;

    function findStartCode(start) {
      for (let i = start; i + 3 < buffer.length; i++) {
        if (
          buffer[i] === 0x00 &&
          buffer[i + 1] === 0x00 &&
          (buffer[i + 2] === 0x01 ||
            (buffer[i + 2] === 0x00 && buffer[i + 3] === 0x01))
        ) {
          return i;
        }
      }
      return -1;
    }

    while (offset < buffer.length) {
      const start = findStartCode(offset);
      if (start === -1) break;

      let startCodeLength = buffer[start + 2] === 0x01 ? 3 : 4;
      let naluStart = start + startCodeLength;
      let nextStart = findStartCode(naluStart);
      if (nextStart === -1) nextStart = buffer.length;

      const nalu = buffer.subarray(naluStart, nextStart);
      const nalUnitType = (nalu[0] >> 1) & 0x3f; // H.265 NALU type

      if (nalUnitType === 32 || nalUnitType === 33 || nalUnitType === 34) {
        naluList.push({ type: nalUnitType, data: nalu });
      }

      offset = nextStart;
    }

    // 按顺序返回 VPS -> SPS -> PPS
    const vps = naluList.find((n) => n.type === 32)?.data;
    const sps = naluList.find((n) => n.type === 33)?.data;
    const pps = naluList.find((n) => n.type === 34)?.data;

    return { vps, sps, pps };
  }

  guessCodec(data) {
    if (data.length < 1) return null;
    const nalUnitTypeH264 = data[0] & 0x1f;
    if (nalUnitTypeH264 === 7) return "H.264";

    const nalUnitTypeH265 = (data[0] >> 1) & 0x3f;
    if (nalUnitTypeH265 === 32 || nalUnitTypeH265 === 33) return "H.265";

    return "unknown";
  }

  parseNalUnitType(data) {
    // 找到 start code (0x000001)
    let i = 0;
    while (i < data.length - 3) {
      if (data[i] === 0 && data[i + 1] === 0 && data[i + 2] === 1) {
        const nalHeader = data[i + 3];
        const nalUnitType = (nalHeader >> 1) & 0x3f;
        return nalUnitType; // 32 = VPS, 33 = SPS, 34 = PPS, 19/20 = IDR, others = non-IDR
      }
      i++;
    }
    return null;
  }

  // : 'h264' | 'h265' | 'unknown'
  detectVideoCodec(data) {
    if (data.length < 5) return "unknown";

    // 查找起始码 0x000001 或 0x00000001
    let offset = 0;
    while (offset + 4 < data.length) {
      if (data[offset] === 0x00 && data[offset + 1] === 0x00) {
        if (data[offset + 2] === 0x01) {
          offset += 3;
          break;
        } else if (data[offset + 2] === 0x00 && data[offset + 3] === 0x01) {
          offset += 4;
          break;
        }
      }
      offset++;
    }

    if (offset >= data.length) return "unknown";

    const nalHeader = data[offset];

    // H.264 NAL 单元类型在最低 5 位
    const nalTypeH264 = nalHeader & 0x1f;
    // H.265 NAL 单元类型在高 6 位
    const nalTypeH265 = (nalHeader >> 1) & 0x3f;

    // 常见类型判断
    if (nalTypeH264 >= 1 && nalTypeH264 <= 12) return "h264";
    if (nalTypeH265 >= 0 && nalTypeH265 <= 40) return "h265";

    return "unknown";
  }

  makeAvcC(sps, pps) {
    const spsLength = sps.length;
    const ppsLength = pps.length;

    const avcc = new Uint8Array(8 + spsLength + 3 + ppsLength);

    let i = 0;
    avcc[i++] = 1; // configurationVersion
    avcc[i++] = sps[1]; // profile
    avcc[i++] = sps[2]; // compatibility
    avcc[i++] = sps[3]; // level
    avcc[i++] = 0xff; // reserved + lengthSizeMinusOne (4 bytes)

    avcc[i++] = 0xe1; // numOfSPS = 1
    avcc[i++] = (spsLength >> 8) & 0xff;
    avcc[i++] = spsLength & 0xff;
    avcc.set(sps, i);
    i += spsLength;

    avcc[i++] = 1; // numOfPPS = 1
    avcc[i++] = (ppsLength >> 8) & 0xff;
    avcc[i++] = ppsLength & 0xff;
    avcc.set(pps, i);

    return avcc;
  }

  /**
   * 解码视频帧
   * @param {ArrayBuffer} data - 视频帧数据
   * @param {number} timestamp - 时间戳
   */
  decodeVideoFrame(data, timestamp, isKey = false) {
    if (!this.videoDecoder) {
      console.warn("VideoDecoder is not initialized");
      return;
    }
    if (this.isDetectAbnormal) {
      console.log(
        "被检测到异常码流了但是还是继续接收到帧去解码推入到解码队列",
        this.videoDecoder._id,
      );
    }
    if (this.videoDecoder.decodeQueueSize > 100 && !isKey) {
      this.decodeSlow = true;
      this.mnWorker.postMessage({
        t: Common.kPauseDecodingReq,
      });
    }

    this.streamTime = Date.now();
    let pixelRatio = window.devicePixelRatio || 1;

    if (!this.isFirstLoad) {
      const type = this.detectVideoCodec(data);
      // console.log("type", type);
      if (type === "unknown") return;
      if (type == "h264") {
        this.frameType = "h264";
        const { sps, pps } = this.extractSpsPps(data);
        if (!sps || !pps) return;
        this.sps = sps;
        this.pps = pps;
        this.avcC = this.makeAvcC(sps, pps);
        console.warn("avcC", this.avcC);
        function spsToCodec(sps) {
          // sps[0] 是 nal header，真正 profile 从 sps[1] 开始
          const profile = sps[1];
          const compat = sps[2];
          const level = sps[3];

          return `avc1.${profile.toString(16).padStart(2, "0")}${compat
            .toString(16)
            .padStart(2, "0")}${level.toString(16).padStart(2, "0")}`;
        }
        let codec = spsToCodec(sps);
        // console.log("codec", codec);
        this.videoDecoder.configure({
          codec, // ⚠️ 要和 SPS 一致
          displayAspectWidth: this.canvas.width || 640,
          displayAspectHeight: this.canvas.height || 480,
          description: this.avcC,
          hardwareAcceleration: "prefer-hardware",
        });
        this.t = 0;
        if (isKey) {
          this.isFirstLoad = true;
        } else {
          return;
        }
      } else {
        this.frameType = "h265";
        const { vps, sps, pps } = this.extractVpsSpsPps(data);
        this.vps = vps;
        this.sps = sps;
        this.pps = pps;
        if (!vps || !sps || !pps) return;
        const config = {
          codec: "hev1.1.6.L93.90",
          codedWidth: 1920,
          codedHeight: 1080,
          hardwareAcceleration: "prefer-hardware",
        };
        VideoDecoder.isConfigSupported(config).then((support) => {
          if (!support.supported) {
            console.warn("VideoDecoder config is not supported:", config);
            return;
          } else {
            console.log("支持");
          }
        });
        this.videoDecoder.configure(config);
        if (isKey) {
          this.isFirstLoad = true;
        } else {
          return;
        }
      }
    }
    // 创建编码视频帧
    if (this.frameType == "h264") {
      let fData = this.annexBToAvcc(this.splitAnnexBNalus(data));
      let d = 33333;
      // console.log('fData', fData)
      const encodedFrame = new EncodedVideoChunk({
        type: isKey ? "key" : "delta", // 根据是否关键帧设置类型
        // type: "key", // 根据是否关键帧设置类型
        // data: this.dropLast16Bytes(data),
        data: fData,
        timestamp: timestamp * 1000, // 转换为微秒
        duration: d, // 假设30fps，约33.33ms
      });
      // console.log("输入界面帧", timestamp, isKey);
      // 解码视频帧
      try {
        this.videoDecoder.decode(encodedFrame);
      } catch (e) {
        console.log("解码错误", this.videoDecoder._id);
      }
    } else {
      let d = 33333;
      const encodedFrame = new EncodedVideoChunk({
        type: isKey ? "key" : "delta", // 根据是否关键帧设置类型
        data: data,
        timestamp: timestamp * 1000, // 转换为微秒
        duration: d, // 假设30fps，约33.33ms
      });
      // 解码视频帧
      try {
        this.videoDecoder.decode(encodedFrame);
      } catch (e) {
        console.log("解码错误", this.videoDecoder._id);
      }
    }
  }

  formatDateTime(date) {
    if (!(date instanceof Date) || isNaN(date.getTime())) {
      return "";
    }
    const pad = (n) => n.toString().padStart(2, "0");
    return (
      date.getFullYear() +
      "-" +
      pad(date.getMonth() + 1) +
      "-" +
      pad(date.getDate()) +
      " " +
      pad(date.getHours()) +
      ":" +
      pad(date.getMinutes()) +
      ":" +
      pad(date.getSeconds())
    );
  }

  /**
   * 关闭 VideoDecoder
   */
  async closeVideoDecoder() {
    try {
      if (this.videoDecoder) {
        this.isFirstLoad = false;
        try {
          // 等待当前所有解码任务完成，清空队列
          await this.videoDecoder.reset();
        } catch (e) {}
        console.log("closeVideoDecoder ID:", this.videoDecoder._id);
        this.videoDecoder.close();
        this.videoDecoder = null;
        console.log("VideoDecoder closed");
      }
    } catch (e) {}
  }

  /**
   * 倍速 (0-无效，1-1倍，2-2倍，3-4倍，4-8倍，5-16倍)
   * 输入 1,2,4,8,16
   **/
  changeSpeed(speed = 1, post = true) {
    let valueMap = new Map([
      [1, 1],
      [2, 2],
      [4, 3],
      [8, 4],
      [16, 5],
    ]);
    let playbackMode = 0;
    if (speed >= 4) {
      playbackMode = 6;
    }
    let req = {
      t: Common.kReplaySpeedReq,
      time: "",
      d: valueMap.get(speed) || 1,
      v: speed,
      playbackMode,
    };
    console.log("changeSpeed", speed, valueMap.get(speed));
    this.speed = speed;
    this.mnAudio.speed(speed);
    this.speedValue = valueMap.get(speed);
    this.timerCtrl.changeSpeed(speed);
    if (post) {
      this.mnWorker.postMessage(req);
    }
    if (this.speed == 1) {
      this.resetAudioOffset(this.videoTimeStamp);
    }
  }

  /**
   * 同步时间
   */
  delayTime(time) {
    /* 同步时间需要将音频时间同步 */
    /* 倍速忽略 */
    if(this.speed >=2) return
    if(this.playerState == playerStatePausing) return
    if(time < 300) return
    if(time > 3000) return
    this.pause()
    setTimeout(() => {
      this.resume();
    }, time)
  }
}

export default MnPlayer;
